// 官网按实际交互加载旧脚本；并发请求复用 Promise，失败后允许用户重试。
const pending = new Map()

function loadScript (src, ready, validateOnLoad = true) {
  if (ready()) return Promise.resolve()
  if (pending.has(src)) return pending.get(src)
  const promise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.async = true
    const finish = error => {
      clearTimeout(timer)
      script.onload = script.onerror = null
      if (error) {
        script.remove()
        reject(error)
      } else resolve()
    }
    const timer = setTimeout(() => finish(new Error('Resource loading timed out')), 15000)
    script.onload = () => finish(!validateOnLoad || ready() ? null : new Error('Resource initialization failed'))
    script.onerror = () => finish(new Error('Resource loading failed'))
    document.head.appendChild(script)
  }).catch(error => {
    pending.delete(src)
    throw error
  })
  pending.set(src, promise)
  return promise
}

export const ensureOpenCC = () => loadScript('/static/js/opencc.js', () => !!window.OpenCC)
// 图标库通过下一轮任务插入 symbol，load 事件只确认脚本执行成功。
export const ensureSiteIcons = () => loadScript('/static/iconfont/iconfont.js', () => !!document.querySelector('svg symbol[id^="icon"]'), false)
